/** CSS contract: css-library/components/03-layouts/modal.css. */
import type { Ref } from 'react';
import type { HTMLAttributes, ReactNode } from 'react';
import { cx } from '../lib/cx';
import { Modal, type ModalSize } from './Modal';

export type ModalSource = { kind: 'bar' | 'row' | 'column' };

export interface SubShellProps extends Omit<HTMLAttributes<HTMLDivElement>, 'children' | 'role'> {
  source?: ModalSource;
  size?: ModalSize;
  onClose?: () => void;
  topbar?: ReactNode;
  children?: ReactNode;
}

export function SubShell(
  { ref, source, onClose, topbar, className, children, size = 'form', ...rest }: SubShellProps & { ref?: Ref<HTMLDivElement> },
) {
  return (
    <Modal ref={ref} onClose={onClose} presentation={source?.kind === 'row' ? 'side' : 'center'} size={size} topbar={topbar} overlayClassName={cx('page-overlay', className)} {...rest}>
      {children}
    </Modal>
  );
}
